import React, { useState } from 'react';
import './BackupArea.css';
import { createBackup, uploadBackupToDB } from '../utils/backups';

interface BackupAreaProps {}

const BackupArea: React.FC<BackupAreaProps> = () => {
  const [status, setStatus] = useState('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleBackupImport = () => {
    if (selectedFile) {
      uploadBackupToDB(setStatus, selectedFile);
    } else {
      setStatus('Bitte eine Datei auswählen.');
    }
  };
  return (
    <div className="backup-container">
      <p className="status-message">{status}</p>
      <button className="update-button" onClick={() => createBackup(setStatus)}>
        Backup erstellen
      </button>
      <input
        className="file-input"
        type="file"
        accept=".encrypted"
        onChange={handleFileChange}
      />
      <button
        className="update-button"
        onClick={handleBackupImport}
        disabled={!selectedFile}
      >
        Backup importieren
      </button>
    </div>
  );
};

export default BackupArea;
